import { useState } from "react";

const faqs = [
  {
    question: "Who repairs solar panels and energy systems near me?",
    answer: "Wired Into The Future specializes in solar repair, maintenance, and optimization across the East Bay — Pleasant Hill, Walnut Creek, Lafayette, and surrounding areas. With 21+ years of experience, we diagnose and fix underperforming systems, inverter faults, wiring issues, and more. A+ BBB rated, fully licensed and insured.",
  },
  {
    question: "How much does solar repair or maintenance cost?",
    answer: "Repair costs depend on the issue — inverter replacement, panel repair, wiring faults, or general maintenance all vary in scope. We provide a free diagnostic estimate before any work begins. Most repairs are completed in a single visit, and we always explain the issue and cost clearly upfront.",
  },
  {
    question: "How long does a solar repair or electrical job take?",
    answer: "Most solar repairs and electrical jobs are completed within one visit — typically a few hours to a full day depending on complexity. Battery storage additions may take 1–2 days. We define the timeline clearly before starting and work around your schedule to minimize disruption.",
  },
  {
    question: "Can you add battery storage to my existing solar system?",
    answer: "Yes — battery storage is one of our core services. We assess your existing solar setup, size the right battery system for your usage and goals, and handle the full installation. Battery backup protects you during outages and maximizes the value of your existing solar investment.",
  },
  {
    question: "Are you licensed for both solar and electrical work?",
    answer: "Fully licensed, bonded, and insured for both solar and electrical. A+ rated by the Better Business Bureau since 2003. All work is code-compliant and performed by licensed professionals — no subcontractors, no shortcuts.",
  },
  {
    question: "Do you offer 24/7 emergency electrical service?",
    answer: "Yes — we provide 24/7 emergency electrical response for urgent issues including panel failures, outages, and hazardous wiring problems. Our licensed team responds quickly, day or night, to diagnose and resolve the issue safely and efficiently.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-3xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-amber-500 text-xs font-bold tracking-[0.2em] uppercase">FAQ</span>
          <h2
            className="text-4xl md:text-5xl font-black text-gray-950 mt-3 mb-4 leading-tight tracking-tight"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Common Questions
          </h2>
          <p className="text-gray-500 text-base max-w-sm mx-auto">
            Straight answers about solar repair, battery storage, and electrical services.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-2">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`rounded-xl overflow-hidden transition-all duration-200 ${
                openIndex === index
                  ? "bg-white border border-amber-200"
                  : "bg-white border border-gray-100 hover:border-gray-200"
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span
                  className="text-sm font-bold pr-6 leading-snug text-gray-900"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  {faq.question}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${openIndex === index ? "bg-amber-500" : "bg-gray-100"}`}>
                  <i className={`text-sm ${openIndex === index ? "ri-subtract-line text-white" : "ri-add-line text-gray-500"}`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
